module.exports = __webpack_public_path__ + "static/use-case-8-content-5-467fc9cb2aa62209c993045d5d91e81a.png";